import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VDialog,{attrs:{"persistent":""},model:{value:(_vm.archivoGrande),callback:function ($$v) {_vm.archivoGrande=$$v},expression:"archivoGrande"}},[_c(VCard,[_c(VCardTitle,[_vm._v(" Archivo demasiado grande ")]),_c(VCardText,[_vm._v(" El archivo seleccionado es demasiado grande. Por favor seleccione un archivo más pequeño (1MB de tamaño). ")]),_c(VCardActions,[_c(VBtn,{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.archivoGrande = false}}},[_vm._v("Aceptar")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }